import { getAccountMe } from "../../api";
import { useQueryWrapper } from "../useQueryWrapper";

export const useAccountMe = () => {
  const { data, isLoading } = useQueryWrapper(["accountMe"], getAccountMe, {
    refetchOnWindowFocus: false,
    refetchOnMount: false
  });

  return { data, loading: isLoading };
};
